import { guestSteps } from '../guest-steps';
import { joinWizard } from './wizard';
import * as messages from './messages';

/**
 * The join form on a chapter or an event page, for somebody with no account.
 *
 * Same four steps as every other guest door, so the whole of it is guest-steps. What
 * door's own is the wording, and messages.js holds it — including the three
 * outcomes that only exist where a chair reviews the request.
 *
 * The page decides between this and member.js: the modal draws one form for a guest
 * and another for somebody already signed in, and only loads the bundle it needs.
 */

$(document).ready(() => {
    joinWizard();
    guestSteps(messages);
});
